import { Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-existing-wo-warning',
  templateUrl: './existing-wo-warning.component.html',
  styleUrls: ['./existing-wo-warning.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExistingWoWarningComponent {
  @Output() public warningClick = new EventEmitter<void>();

  public onClick(): void {
    this.warningClick.emit();
  }
}
